import React from 'react';
import { 
  BelongingHeartIcon, 
  WisdomScrollIcon, 
  PhiSpiralIcon, 
  SacredWrenchIcon,
  CoherenceLeafIcon,
  SpiralIcon,
  BlissAbodeIcon,
  SketchHubIcon
} from './CustomIcons';

/**
 * EcosystemNav - Mobile-app-style bottom navigation for the Belonging ecosystem
 * Compact, unobtrusive, but accessible across all pages
 * Uses bespoke sacred geometry icons from the M.ai.ry icon library
 */
const EcosystemNav = ({ variant = 'terminal' }) => {
  const links = [
    {
      href: "https://belongingsessions.com",
      label: "Home",
      IconComponent: BelongingHeartIcon,
      iconColor: "#fbbf24",
      gradient: "from-amber-500/20 to-amber-600/30",
      border: "border-amber-500/30",
      hoverGradient: "group-hover:from-amber-500/30 group-hover:to-amber-600/40"
    },
    {
      href: "https://belongingsessions.com/ebook",
      label: "E-book",
      IconComponent: WisdomScrollIcon,
      iconColor: "#f59e0b",
      gradient: "from-amber-500/20 to-amber-600/30",
      border: "border-amber-500/30",
      hoverGradient: "group-hover:from-amber-500/30 group-hover:to-amber-600/40"
    },
    {
      href: "https://elchme.com",
      label: "ElchmE",
      IconComponent: PhiSpiralIcon,
      iconColor: "#a78bfa",
      gradient: "from-purple-500/20 to-purple-600/30",
      border: "border-purple-500/30",
      hoverGradient: "group-hover:from-purple-500/30 group-hover:to-purple-600/40"
    },
    {
      href: "https://elchme.com/sketch",
      label: "Sketch",
      IconComponent: SketchHubIcon,
      iconColor: "#c084fc",
      gradient: "from-violet-500/20 to-purple-600/30",
      border: "border-violet-500/30",
      hoverGradient: "group-hover:from-violet-500/30 group-hover:to-purple-600/40"
    },
    {
      href: "https://belongingsessions.com/dashboard",
      label: "F+N",
      IconComponent: SacredWrenchIcon,
      iconColor: "#34d399",
      gradient: "from-emerald-500/20 to-teal-600/30",
      border: "border-emerald-500/30",
      hoverGradient: "group-hover:from-emerald-500/30 group-hover:to-teal-600/40"
    },
    {
      href: "https://defiancesprings.com",
      label: "Defiance",
      IconComponent: CoherenceLeafIcon,
      iconColor: "#4ade80",
      gradient: "from-emerald-500/20 to-emerald-600/30",
      border: "border-emerald-500/30",
      hoverGradient: "group-hover:from-emerald-500/30 group-hover:to-emerald-600/40"
    },
    {
      href: "https://blissabode.org",
      label: "Bliss Abode",
      IconComponent: BlissAbodeIcon,
      iconColor: "#f9a8d4",
      gradient: "from-pink-500/20 to-rose-600/30",
      border: "border-pink-500/30",
      hoverGradient: "group-hover:from-pink-500/30 group-hover:to-rose-600/40"
    },
    {
      href: "https://belongingsessions.com/login",
      label: "Login",
      IconComponent: SpiralIcon,
      iconColor: "#60a5fa",
      gradient: "from-blue-500/20 to-indigo-600/30",
      border: "border-blue-500/30",
      hoverGradient: "group-hover:from-blue-500/30 group-hover:to-indigo-600/40"
    }
  ];

  return (
    <nav className="relative z-20 bg-gradient-to-r from-slate-900/95 via-slate-800/95 to-slate-900/95 backdrop-blur-sm border-t border-slate-700/50">
      <div className="max-w-screen-lg mx-auto px-2 py-3">
        {/* Title - very subtle */}
        <p className="text-center text-slate-500 text-[9px] tracking-widest mb-2 uppercase">
          Ecosystem
        </p>
        
        {/* Navigation items - compact mobile-style */}
        <div className="flex items-center justify-center gap-3 sm:gap-4 md:gap-6">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col items-center gap-1 transition-all duration-200 hover:scale-105 active:scale-95"
              data-testid={`ecosystem-nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {/* Icon circle - compact size */}
              <div className={`
                w-10 h-10 sm:w-11 sm:h-11 
                rounded-full 
                bg-gradient-to-br ${link.gradient} ${link.hoverGradient}
                flex items-center justify-center 
                transition-all duration-200
                border ${link.border}
                shadow-sm
              `}>
                <link.IconComponent size={20} color={link.iconColor} className="group-hover:scale-110 transition-transform" />
              </div>
              
              {/* Label - very small */}
              <span className="text-[9px] sm:text-[10px] font-medium text-slate-400 group-hover:text-slate-200 transition-colors">
                {link.label}
              </span>
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default EcosystemNav;
